<template>
  <div class="visualizer">
    <div class="lds-ripple" v-if="!loadingComplete"><div></div><div></div></div>
    <div class="backgrounds" v-bind:class="{ visible: loadingComplete }">
      <div ref="bg1" class="background background--1"></div>
      <div ref="bg1_2" class="background background--1-2"></div>
      <div ref="bg2" class="background background--2"></div>
      <div ref="bg2_2" class="background background--2-2"></div>
      <div ref="bg3" class="background background--3"></div>
      <div ref="bg3_2" class="background background--3-2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BirdVisualizer',
  props: ['analyser', 'stereoPos', 'distanceDirection', 'userAlpha'],
  mounted() {
    this.bgs = [this.$refs.bg1, this.$refs.bg2, this.$refs.bg3]
    this.bgs2 = [this.$refs.bg1_2, this.$refs.bg2_2, this.$refs.bg3_2]

    this.initLoading();
    // this.initDraw();

    this.initCanvas();
  },
  data: () => {
    return {
      currentAlpha: 0,
      currentBgX: 0,
      currentBg2X: 0,
      images: [
        require('../assets/bg-front.png'),
        require('../assets/bg-middle.png'),
        require('../assets/bg-back.png')
      ],
      imagesLoaded: 0,
      loadingComplete: false,
      alphaSet: false
    }
  },
  watch: {
    userAlpha: function(newVar) {
      if(this.alphaSet) return;
      if(newVar != 0) {
        this.alphaSet = true;
        this.currentAlpha = newVar;
      }
    }
  },
  methods: {
    initLoading() {
      for(let i=0; i<this.bgs.length; i++) {
        
        let img = new Image();
        img.onload = () => {
          this.imagesLoaded++;
          this.bgs[i].style.backgroundImage = 'url(' + this.images[i] + ')';
          this.bgs2[i].style.backgroundImage = 'url(' + this.images[i] + ')';
          if(this.imagesLoaded === this.images.length) {
            this.loadingComplete = true;
            this.initDraw();
          }
        }
        img.src = this.images[i];
      }
    },
    initCanvas() {
      // const app = new PIXI.Application();
      // this.$el.appendChild(app.view);
      // const container = new PIXI.ParticleContainer();
      // app.stage.addChild(container);
    },
    initDraw() {
      const normaliseAngle = (angle) => {
        while (angle < 0) angle += 360;
        while (angle > 360) angle -= 360;
        return angle;
      }
      
      const draw = () => {
        requestAnimationFrame(draw);

        let dX;
        if(this.currentAlpha > 270 && this.userAlpha < 90) {
          dX = this.userAlpha + 360 - this.currentAlpha;
        }else if(this.userAlpha > 270 && this.currentAlpha < 90) {
          dX = -(this.currentAlpha + 360 - this.userAlpha);
        }else{
          dX = this.userAlpha - this.currentAlpha;
        }
        // let bgX = (this.userAlpha / 360) * 100;
        // let dX = bgX - this.currentBgX;
        this.currentAlpha += dX * .1;
        this.currentAlpha = normaliseAngle(this.currentAlpha);
        let bgX = (this.currentAlpha / 360) * 100;
        // this.currentBgX += dX / 10;

        this.bgs.forEach((bg) => {
          bg.style.transform = 'translate3d(' + bgX + '%, 0, 0)';
        });
        this.bgs2.forEach((bg) => {
          bg.style.transform = 'translate3d(' + (bgX - 100) + '%, 0, 0)';
        });
      }

      draw();
      
    }
  }
}
</script>

<style scoped lang="scss">

.visualizer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.backgrounds {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: 1s opacity;

  &.visible {
    opacity: 1;
  }
}
.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vh;
  height: 100vh;
  background-size: auto 100%;
  background-position: 0 0;
  will-change: transform;
  // animation: fadein 5s;

  &--1, &--1-2 {
    width: 300vh;
    z-index: 3;
    // background-image: url('../assets/bg-front.png');
  }
  &--2, &--2-2 {
    width: 218.75vh;
    z-index: 2;
    // background-image: url('../assets/bg-middle.png');
  }
  &--3, &--3-2 {
    width: 187.5vh;
    z-index: 1;
    // background-image: url('../assets/bg-back.png');
  }
}

.loader {
  color: #fff;
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.lds-ripple {
  display: block;
  position: relative;
  width: 120px;
  height: 120px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.lds-ripple div {
  position: absolute;
  border: 6px solid var(--color-main);
  opacity: 1;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  animation: lds-ripple 1.5s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}
.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}
@keyframes lds-ripple {
  0% {
    transform: scale(0);
    opacity: .4;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}


</style>
